import { Button, Col, Row, Tooltip, Descriptions, Alert, Table } from "antd";
import { useContext, useState } from "react";
import Axios from "axios";
import DashboardContext from "Context";
import InputControl from "components/inputs/InputControl";

export default function Paycheck({ id }) {
  const { urldashboard, authentication } = useContext(DashboardContext);

  const [info, setInfo] = useState({});
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const getReport = async ({ formData }) => {
    setLoading(true);
    try {
      let url = "/workerCalculationMonthlySalary/getPayslip";
      const res = await Axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          "Content-Type": "application/json",
        },
        params: { workerId: id, ...formData },
      });
      const data = await res?.data?.data;
      setInfo(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setInfo({});
    }
  };

  const search = () => {
    getReport({
      formData,
    });
  };

  const columns = [
    {
      title: "عنوان",
      dataIndex: "name",
      key: "name",
      responsive: ["xl", "lg", "md"],
      render: (value) => <span>{value ? value : "-"}</span>,
    },
    {
      title: "تعداد",
      dataIndex: "count",
      key: "count",
      responsive: ["xl", "lg", "md"],
    },
    {
      title: "مبلغ (ریال)",
      dataIndex: "totalAmount",
      align: "center",
      render: (value) => <span>{value?.toLocaleString()}</span>,
    },
  ];

  return (
    <>
      <Row gutter={20} align={"middle"}>
        <Col xl={6} lg={6} md={12} sm={24} xs={24}>
          <InputControl
            url='/common/getYears'
            label='سال'
            name='year'
            handelValue={(_, value) => handleChange("year", value)}
          />
        </Col>
        <Col xl={6} lg={6} md={12} sm={24} xs={24}>
          <InputControl
            url='/common/getMonths'
            label='ماه'
            name='month'
            handelValue={(_, value) => handleChange("month", value)}
          />
        </Col>
      </Row>
      {/* */}
      <Row
        gutter={20}
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 20,
        }}
      >
        <Col xl={6} lg={6} md={24} sm={24} xs={24}>
          <Button
            type='primary'
            style={{ width: "100%" }}
            loading={loading}
            onClick={() => search()}
          >
            جستجو
          </Button>
        </Col>
      </Row>

      {Object.keys(info).length < 1 ? (
        <Row>
          <Col span={24} style={{ margin: "2rem 0" }}>
            <Alert
              message='برای نمایش اطلاعات، ابتدا ماه و سال مد نظر خود را انتخاب کنید.'
              type='info'
            />
          </Col>
        </Row>
      ) : (
        <Row>
          <Col span={24} style={{ margin: "2rem 0" }}>
            <Descriptions bordered column={4} size={"small"} layout='vertical'>
              <Descriptions.Item label='تعداد کار'>
                {info?.totalWork}
              </Descriptions.Item>
              <Descriptions.Item label='مجموع پرداختی به نیرو (ریال)'>
                {info?.totalPayments}
              </Descriptions.Item>
              <Descriptions.Item label='مجموع درآمدهای خالص (ریال)'>
                {info?.amountOfNetIncome >= 0
                  ? info?.amountOfNetIncome?.toLocaleString()
                  : `${Math.abs(info?.amountOfNetIncome)?.toLocaleString()} -`}
              </Descriptions.Item>
            </Descriptions>
          </Col>

          <Col span={24} style={{ margin: "2rem 0" }}>
            <Table
              size='small'
              style={{ textAlign: "right", marginTop: 10 }}
              rowClassName={() => "center"}
              columns={columns}
              bordered={true}
              dataSource={info?.grossRevenues}
              loading={loading}
              pagination={false}
              title={() => "درآمدها"}
              footer={() => (
                <div
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <span>مجموع درآمدهای ناخالص</span>
                  <span>
                    {info?.amountOfGrossRevenue >= 0
                      ? info?.amountOfGrossRevenue?.toLocaleString()
                      : `${Math.abs(
                          info?.amountOfGrossRevenue
                        )?.toLocaleString()} -`}{" "}
                    ریال
                  </span>
                </div>
              )}
              locale={{
                emptyText: "موردی یافت نشد",
              }}
            />
          </Col>

          <Col span={24} style={{ margin: "2rem 0" }}>
            <Table
              size='small'
              style={{ textAlign: "right", marginTop: 10 }}
              rowClassName={() => "center"}
              columns={columns}
              bordered={true}
              dataSource={info?.costs}
              loading={loading}
              pagination={false}
              title={() => "هزینه‌ها"}
              footer={() => (
                <div
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <span>مجموع هزینه‌ها</span>
                  <span>
                    {info?.amountOfCosts >= 0
                      ? info?.amountOfCosts?.toLocaleString()
                      : `${Math.abs(
                          info?.amountOfCosts
                        )?.toLocaleString()} -`}{" "}
                    ریال
                  </span>
                </div>
              )}
              locale={{
                emptyText: "موردی یافت نشد",
              }}
            />
          </Col>
        </Row>
      )}
    </>
  );
}
